export default [
    {
        path: "/camp-parade-state",
        component: () => import("../Components/List.vue"),
        name: "camp-parade-state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/camp-parade-state/create",
        component: () => import("../Components/Create.vue"),
        name: "camp-parade-state-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/camp-parade-state/:id/show",
        component: () => import("../Components/Show.vue"),
        name: "camp-parade-state-show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/camp-parade-state/:id/summary",
        component: () => import("../Components/ParadeSummary.vue"),
        name: "camp-parade-state-summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/camp-parade-state/:id/details",
        component: () => import("../Components/Details.vue"),
        name: "camp-parade-state-details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/camp-parade-state/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "camp-parade-state-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
